module.exports = __webpack_public_path__ + "static/ntg_main-50bd0bfe1538871a1069f47dd9bfef28.svg";